import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import InputMask from 'react-input-mask';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import Notifications, {notify} from 'react-notify-toast';


@inject('userStore')
@withRouter
class AccountSettings extends Component {
    constructor(props){
        super(props);
        this.state = {
          user:null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
      this.setState({
        user:this.props.userStore
      })
    }

    saveUser = () => {
      let updated_item = Object.assign({}, this.state.user);
      delete updated_item["business_primary"];
      delete updated_item["role_list"];
      delete updated_item["businessList"];
      post('/v2/save/user', {item:updated_item},{
          auth: {username: this.props.userStore.token}
      }).then((res) => {
          if (res.data.errors === 0){
              this.props.userStore.first_name = res.data.user.first_name;
              this.props.userStore.last_name = res.data.user.last_name;
              this.props.userStore.full_name = res.data.user.full_name;
              this.props.userStore.email = res.data.user.email;
              this.props.userStore.phone_primary = res.data.user.phone_primary;
              notify.show(res.data.message, "success", 4000);
          } else {
              notify.show(res.data.message, "error", 4000);
          }
      }).catch((error) => {
          notify.show(error, "error", 4000);
          console.log(error);
          return error;
      });
    }

    handleInputChange(e) {
        let updatedSelectedItem = Object.assign({}, this.state.user);
        updatedSelectedItem[e.target.name] = e.target.value;
        // if (e.target.name === 'password_verify' && (updatedSelectedItem.password && updatedSelectedItem.password !== '')){
        //   if (updatedSelectedItem.password !== updatedSelectedItem.password_verify){
        //     notify.show("Passwords must match.  Please correct", "error", 4000);
        //   }
        // }
        this.setState({user:updatedSelectedItem});
    }


    render() {
      if (!this.state.user) return <div className="alert alert-info">Loading Account...</div>;
      const {modalBackgroundHandler} = this.props;
      const {user} = this.state;
      return (
      <React.Fragment>
      <Notifications/>
      <div className="main-content">
        <div className="col-sm-12">
          <div className="card form-type-combine">
              <h4 className="card-title"><strong>Account Settings</strong></h4>
              <div className="card-body form-type-combine">
                <div className="form-groups-attached">
                    <div className="row">
                        <div className="form-group col-6">
                            <label>First Name</label>
                            <input className="form-control" name="first_name" type="text" onChange={this.handleInputChange} value={user.first_name}/>
                        </div>
                        <div className="form-group col-6">
                            <label>Last Name</label>
                            <input className="form-control" name="last_name" type="text" onChange={this.handleInputChange} value={user.last_name}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Phone</label>
                            <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone_primary" value={user.phone_primary} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Email</label>
                            <input className="form-control" name="email" type="text" onChange={this.handleInputChange} value={user.email}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>New Password (leave blank if you are not updating password)</label>
                            <input className="form-control" name="password" type="password" onChange={this.handleInputChange} value={user.password}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Verify Password</label>
                            <input className="form-control" name="password_verify" type="password" onChange={this.handleInputChange} value={user.password_verify}/>
                        </div>
                    </div>
                </div>
              </div>
              <div className="card-footer">
                <div className="pull-right">
                  <button type="button" className="btn btn-primary" onClick={this.saveUser}>
                    Save
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
      </React.Fragment>);
    }
}

export default AccountSettings;



// WEBPACK FOOTER //
// ./src/components/controls/AccountSettings.js